module.exports = __webpack_public_path__ + "static/img/2013.93e55e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2013.png
// module id = cBwW
// module chunks = 1